export default __webpack_public_path__ + "static/media/cif-nu.ae5f0f08.svg";